import { Injectable } from "@angular/core";
import { ViolationObservation } from "../types/Violation/ViolationObservation";
import { ClientService } from "../services/client.service";
import { ArrayClientRepository } from "./abstract/array.client.repository";

@Injectable({
  providedIn: "root",
})
export class IrefItemObservationRepository extends ArrayClientRepository<ViolationObservation> {
  constructor(clientService: ClientService) {
    super(
      clientService,
      "schemas.schCFG_IREF_Item_Obs.records",
      "observationID",
    );
  }
}
